export default {
	name	: 'MainCheckbox',
	props	: {
		checked		: Boolean,
		disabled	: Boolean,
		label		: String
	}
}
